import { type CountryCode, isSupportedCountry, isValidPhoneNumber } from 'libphonenumber-js/min';
import { create, enforce, omitWhen, skipWhen, test } from 'vest';

import { EmergencyContactRelation } from '@/common/graphql';
import type { EmergencyContactFormDataType } from '@/common/types';

export const emergencyContactFormValidationSuite = create(
  ({ name, phoneNumber, phoneNumberCountryCode, relation, remarks }: EmergencyContactFormDataType) => {
    test('name', 'Name is required', () => {
      enforce(name).isNotEmpty();
    });
    test('relation', 'Relation is required', () => {
      enforce(relation).isNotEmpty();
    });

    test('phoneNumber', 'Phone Number is required', () => {
      enforce(phoneNumber).isNotEmpty();
    });

    omitWhen(relation !== EmergencyContactRelation.Other, () =>
      test('remarks', 'Remarks is required', () => {
        enforce(remarks).isNotBlank();
      }),
    );

    skipWhen(!phoneNumber, () =>
      test('phoneNumber', 'Enter a valid phone number', () => {
        enforce(
          !!phoneNumberCountryCode &&
            isSupportedCountry(phoneNumberCountryCode as string) &&
            isValidPhoneNumber(phoneNumber as string, phoneNumberCountryCode as CountryCode),
        ).isTruthy();
      }),
    );
  },
);
